<div class="px-0">
  <app-sent-basket-overview></app-sent-basket-overview>
</div>
